import { safeLocalStorage } from '../utils/safeLocalStorage';

const isProductionBuild = import.meta.env.PROD;

const featureFlags = {
  bypassKycKybApproval: !isProductionBuild,

  useBackendArDriveUpload: true,
};

export function isFeatureEnabled(flag: keyof typeof featureFlags): boolean {
  if (flag === 'bypassKycKybApproval' && isProductionBuild) {
    return false;
  }

  const override = safeLocalStorage.getItem(`feature_${flag}`);
  if (override !== null) {
    return override === 'true';
  }

  return featureFlags[flag];
}

export function isKycKybBypassEnabled(): boolean {
  return isFeatureEnabled('bypassKycKybApproval');
}
